export class ActualizarEstadoSiiRequest {
   Dtes: string[];
   emisorId: string;
   usuarioId: string;
}
